import { MonthsNumberMap } from "../enums";

const getReadableNumber = (num: number) => {
  if (num < 10) {
    return `0${num}`;
  }
  return `${num}`;
};

interface IGetExpDateParams {
  expDateMonth: keyof typeof MonthsNumberMap;
  expDateYear: string | number;
}
export const getExpDate = ({ expDateMonth, expDateYear }: IGetExpDateParams) => {
  const last2 = `${expDateYear}`.slice(-2);
  const number = MonthsNumberMap[expDateMonth];
  return `${getReadableNumber(number)}${last2}`;
};
